import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { provideAppIcons } from './shared/utils/register-icon';
import { registerLocaleData } from '@angular/common';
import localeAt from '@angular/common/locales/de-AT';
import { CustomDateAdapter } from './shared/classes/date.adapter';
import { Platform } from '@angular/cdk/platform';
import { ContestSettingsStore } from './shared/stores/contest-settings.store';
import { ContestSettingsService } from './shared/services/contest-settings.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorTranslationService } from './shared/services/paginator-translation.service';

registerLocaleData(localeAt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideAnimations(),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic'
      }
    },
    provideHttpClient(withFetch()),
    importProvidersFrom(MatIconModule),
    provideAppIcons(),
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
      deps: [MAT_DATE_LOCALE, Platform]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MAT_NATIVE_DATE_FORMATS
    },
    {
      provide: LOCALE_ID,
      useValue: 'de-AT'
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'de-AT'
    },
    ContestSettingsStore,
    ContestSettingsService,
    {provide: MatPaginatorIntl, useClass: PaginatorTranslationService}
  ]
};
